import { render, staticRenderFns } from "./TheHeaderTab.vue?vue&type=template&id=ace75724&scoped=true&"
import script from "./TheHeaderTab.vue?vue&type=script&lang=js&"
export * from "./TheHeaderTab.vue?vue&type=script&lang=js&"
import style0 from "./TheHeaderTab.vue?vue&type=style&index=0&id=ace75724&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace75724",
  null
  
)

export default component.exports